import {inject, Injectable} from '@angular/core';
import {TelegramAccountsApiService} from "./telegram-accounts-api.service";
import {
  CreateTelegramAccountParams,
  GetTelegramCodeParams,
  SetTelegramCodeParams, TelegramAccount
} from "../types/add-telegram-accounts.types";

@Injectable({
  providedIn: 'root'
})
export class TelegramAccountsService {
  private telegramAccountsApiService: TelegramAccountsApiService = inject(TelegramAccountsApiService);

  public async getTelegramCode(getTelegramCodeParams: GetTelegramCodeParams): Promise<void> {
    return new Promise((resolve, reject) => {
      this.telegramAccountsApiService.getTelegramCode(getTelegramCodeParams).subscribe({
        next: () => resolve(),
        error: (error) => reject(error)
      });
    });
  }

  public async setTelegramCode(setTelegramCodeParams: SetTelegramCodeParams): Promise<void> {
    return new Promise((resolve, reject) => {
      this.telegramAccountsApiService.setTelegramCode(setTelegramCodeParams).subscribe({
        next: () => resolve(),
        error: (error) => reject(error)
      });
    });
  }

  public async createTelegramAccount(createTelegramAccountParams: CreateTelegramAccountParams): Promise<TelegramAccount> {
    return new Promise((resolve, reject) => {
      this.telegramAccountsApiService.createTelegramAccount(createTelegramAccountParams).subscribe({
        next: (telegramAccount: TelegramAccount) => resolve(telegramAccount),
        error: (error) => reject(error)
      });
    });
  }
}
